// LoadingScreen.js — v3 : intro cinématique avec animations

import React, { useEffect, useState } from 'react';

export function LoadingScreen({ onComplete }) {
  const [phase, setPhase] = useState(0);

  useEffect(() => {
    const t1 = setTimeout(() => setPhase(1), 300);   // logo apparaît
    const t2 = setTimeout(() => setPhase(2), 1200);  // texte apparaît
    const t3 = setTimeout(() => setPhase(3), 2400);  // barre + hint
    const t4 = setTimeout(() => setPhase(4), 4000);  // fade out
    const t5 = setTimeout(() => onComplete(), 4600);
    return () => [t1,t2,t3,t4,t5].forEach(clearTimeout);
  }, [onComplete]);

  return (
    <div className={`loading-screen ${phase === 4 ? 'ls-fade-out' : ''}`}>

      {/* Étoiles */}
      <div className="ls-stars" />

      {/* Rayons lumineux derrière le logo */}
      <div className={`ls-rays ${phase >= 1 ? 'ls-rays-in' : ''}`} />

      {/* Logo */}
      <div className={`ls-logo-wrap ${phase >= 1 ? 'ls-logo-in' : ''}`}>
        <img
          src="/kairos_logo.png"
          alt="Kronotera"
          className="ls-logo-img"
        />
        {/* Halo pulsant */}
        <div className="ls-logo-halo" />
      </div>

      {/* Nom */}
      <div className={`ls-name-wrap ${phase >= 2 ? 'ls-name-in' : ''}`}>
        <div className="ls-name-letters">
          {'KRONOTERA'.split('').map((l, i) => (
            <span
              key={i}
              className="ls-letter"
              style={{ animationDelay: `${i * 0.06}s` }}
            >
              {l}
            </span>
          ))}
        </div>
        <div className={`ls-tagline-wrap ${phase >= 2 ? 'ls-tagline-in' : ''}`}>
          <span className="ls-tagline-line" />
          <span className="ls-tagline-text">Globe Historique Interactif</span>
          <span className="ls-tagline-line" />
        </div>
      </div>

      {/* Baseline + loader */}
      <div className={`ls-bottom ${phase >= 3 ? 'ls-bottom-in' : ''}`}>
        <div className="ls-loader">
          <div className="ls-loader-bar" />
        </div>
        <span className="ls-hint">De −3500 av. J.-C. à aujourd'hui</span>
      </div>

    </div>
  );
}
